/* eslint-disable @typescript-eslint/no-explicit-any */
import { FileStatus, TCompleteFile } from './vv-types';
import {
    setContinueUpload,
    setIsUploadingFile
} from 'core/stores/deposit-now-store';

class FileUploadQueue {
    private queue: TCompleteFile[] = [];
    private activeUploads = 0;
    private maxConcurrent = 1;
    private startUploadFn: any;
    private continueUpload = true;
    public updateStatusFn: (file: TCompleteFile, newStatus: FileStatus) => void;
    public updateProgressFn: (file: TCompleteFile, progress: number) => void;
    private onCompleteFn: (file: TCompleteFile) => void;

    constructor(
        startUploadFn: any,
        updateStatusFn: (file: TCompleteFile, newStatus: FileStatus) => void,
        updateProgressFn: (file: TCompleteFile, progress: number) => void,
        onCompleteFn: (file: TCompleteFile) => void
    ) {
        this.startUploadFn = startUploadFn;
        this.updateStatusFn = updateStatusFn;
        this.updateProgressFn = updateProgressFn;
        this.onCompleteFn = onCompleteFn;
    }

    enqueue(file: TCompleteFile): void {
        this.continueUpload = true;
        const queueItem = {
            ...file,
            status: 'queued' as FileStatus,
            progress: 0,
            retryCount: 0
        };
        this.queue.push(queueItem);
        setIsUploadingFile(true);
        setTimeout(() => this.processQueue(), 0);
    }

    removeFileFromQueue(fileName: string): void {
        const itemInQueue = this.queue.find(
            (item) => item.fileName === fileName
        );
        if (!itemInQueue) {
            return;
        }
        this.queue = this.queue.filter((item) => item.fileName !== fileName);
        this.processQueue();
    }

    stopUpload() {
        setContinueUpload(false);
    }

    private processQueue(): void {
        if (this.queue.length === 0 && this.activeUploads === 0) {
            setIsUploadingFile(false);
        }
        while (
            this.activeUploads < this.maxConcurrent &&
            this.queue.length > 0
        ) {
            const currentItem = this.queue[0];
            setContinueUpload(true);
            this.uploadFile(currentItem);
            this.queue.splice(0, 1);
        }
    }

    private uploadFile(file: TCompleteFile): void {
        file.status = 'uploading';
        this.activeUploads++;

        this.updateStatusFn(file, 'uploading' as FileStatus);
        this.startUploadFn(
            [
                file,
                (newF: boolean, progress = 0) => {
                    if (!newF) {
                        this.updateProgressFn(file, progress);
                    }
                },
                this.continueUpload
            ],
            {
                onSuccess: () => {
                    this.activeUploads--;
                    this.onCompleteFn(file);
                    this.processQueue();
                },
                onError: () => {
                    this.updateStatusFn(file, 'failed' as FileStatus);
                    this.activeUploads--;

                    if (file.retryCount < 3) {
                        file.retryCount++;
                        this.enqueue(file);
                    }
                }
            }
        );
    }
}

export default FileUploadQueue;
